<template>
<div class="left">
  <ul class="xx">
    <li @click="showZCMG= true;showdhDL=false">
      <img src="@/assets/img/ewm.png" alt="">
      <p>顾客扫码注册</p>
    </li>
    <li @click="getsm">
      <img src="@/assets/img/sm.png" alt="">
      <p>顾客扫描登录</p>
    </li>
    <li @click="showZCMG= true;showdhDL = true">
      <img src="@/assets/img/dh.png" alt="">
      <p>顾客手机登录</p>
    </li>
    <li  @click="$router.push({path: '/reservationRecord'})">
      <img src="@/assets/img/yy.png" alt="">
      <p>顾客预约记录</p>
    </li>
  </ul>
  <div class="ssgk">
    <p style="padding-bottom: 5px;">搜索顾客</p>
    <el-date-picker
        format="yyyy/MM/dd"
        value-format="yyyy/MM/dd"
        style="width: 100%;height:35px;"
        v-model="tiem"
        type="daterange"
        size="large"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
    </el-date-picker>
    <div class="ssk">
      <el-input size="mini" v-model="name" placeholder="请输入内容"></el-input>
      <i class="el-icon-search" @click="searchCs"></i>
    </div>
  </div>


  <div class="smzc" v-if="showZCMG">
    <div class="smbox">
      <p   class="gbccss" @click="showZCMG = false"><i class="el-icon-close"></i></p>
      <img  v-if="!showdhDL"  :src="src" alt="">
      <p  v-if="!showdhDL" class="smwz">【请扫码注册个人信息】</p>

      <input v-if="showdhDL" v-model="names"  type="text" class="na" placeholder="请输入姓名">
      <input v-if="showdhDL"  v-model="tel" type="text" placeholder="请输入手机号码">
      <p v-if="showdhDL"  @click="gldl" class="gkdlan">顾客登录</p>
      <p v-if="showdhDL"  @click="newzc" class="gkdlan" style="margin-top: 20px;">注册</p>
    </div>
  </div>
  <div class="smzc" v-if="showSJZC">
    <div class="zcsjbox" style="padding-top: 50px">
      <p class="gbccss" @click="showSJZC=false">×</p>
      <div class="srbox">
        <p>姓名：</p>
        <input v-model="csZcObj.name" type="text">
      </div>
      <div class="srbox">
        <p>电话：</p>
        <input v-model="csZcObj.tel" type="number">
      </div>
      <div class="srbox">
        <p>性别：</p>
        <div style="display: flex;width: 168px;">
          <el-radio class="radios" style="margin-right: 20px;" v-model:value="csZcObj.sex" :val="'1'" :label="'1'">男</el-radio>
          <el-radio class="radios" v-model:value="csZcObj.sex" :val="'0'" :label="'0'">女</el-radio>
        </div>
      </div>
      <div class="srbox">
        <p>生日：</p>
        <el-date-picker
            style="width: 168px"
            v-model="csZcObj.sr"
            type="date"
            format="yyyy/MM/dd"
            value-format="yyyy/MM/dd"
        />
      </div>
<!--      <div class="srbox">-->
<!--        <p>地区：</p>-->
<!--        <el-cascader-->
<!--            style="width: 168px"-->
<!--            v-model="csZcObj.dq"-->
<!--            :options="addList"-->
<!--            :props="{value: 'AreaId', label: 'AreaName', children: 'ListArea'}"-->
<!--            @change="dqBH"-->
<!--        />-->
<!--      </div>-->
      <div class="srbox">
        <p>详细地址：</p>
        <input v-model="csZcObj.xxdz" type="text">
      </div>
      <div  @click="csZCS" class="gkdlan">注册并登录</div>
    </div>
  </div>




  <el-collapse v-model="activeNames" accordion @change="handleChange">
    <el-collapse-item title="本店当天顾客" name="1">
      <ul class="gklb" ref="dayList" @scroll="handleListScroll">
        <li v-for="(item, idx) in gkList" @click="ling(item, idx)" :class="dqGkIdx == idx ? 'xz' : ''">
          <i class="el-icon-s-custom"></i>
          <p>{{item.CustomerName}}</p>
        </li>
        <li v-if="listLoading" class="list-tip">加载中...</li>
        <li v-else-if="gkList.length && !hasMore" class="list-tip">没有更多了</li>
      </ul>
    </el-collapse-item>
    <el-collapse-item title="本店所有顾客" name="2">
      <ul class="gklb" ref="allList" @scroll="handleListScroll">
        <li v-for="(item, idx) in gkList" @click="ling(item, idx)"  :class="dqGkIdx == idx ? 'xz' : ''">
          <i class="el-icon-s-custom"></i>
          <p>{{item.CustomerName}}</p>
        </li>
        <li v-if="listLoading" class="list-tip">加载中...</li>
        <li v-else-if="gkList.length && !hasMore" class="list-tip">没有更多了</li>
      </ul>
    </el-collapse-item>
  </el-collapse>
</div>
</template>

<script>
import {Loading} from "element-ui";
import pf from "@/publicFn/baseFn"

export default {
  name: "left",
  data() {
    return {
      tiem: ['', ''],
      names: '',
      tel: '',
      name: '',
      activeNames: '',
      gkList: [],
      dqGkIdx: -1,
      showZCMG : false,
      src: "",
      showdhDL: false,
      showSJZC: false,
      pageSize: 50,
      pageMin: 1,
      totalCount: 0,
      hasMore: true,
      listLoading: false,
      isSearchMode: false,
      csZcObj: {
        name: '',
        tel: '',
        sex: '',
        dq: '',
        xxdz: "",
        sr: ''
      },
      addList: [],
    }
  },
  created() {
    let url = this.$store.state.bases.shop.ShopWXQRCodeURL
    if (!url) url = pf.getUrl('customCompanyQRCode') + this.$store.state.users.user.Company.CompanyWXQRCode
    this.src =  url

    const _this = this
    window.getScanResult = function (res) {
      if (res) {
        // let loadingInstance = _this.$loading({
        //   background: 'rgba(0, 0, 0, 0.7)',
        //   text: '登录中...'
        // });
        _this._api.userCurdApi.codeLing(res)
            .then(res => {
              // loadingInstance.clone()
              if (res.LoginOnCustomerNoResult.Customer) {
                let datas = res.LoginOnCustomerNoResult.Customer
                _this.cancellation()
                _this.$store.commit('users/UpCsUser', datas )
                _this.$store.commit('users/upCsAge', datas.CustomerAge)
                _this.$store.commit('users/upCsUserItem', {
                  name: datas.CustomerName,
                  tel: datas.CustomerTel
                })
              }
            })
      }
    }

  },
  methods: {
    resetPage() {
      this.pageMin = 1
      this.totalCount = 0
      this.hasMore = true
      this.isSearchMode = false
      this.gkList = []
      this.dqGkIdx = -1
    },
    handleChange(e) {
      if (!e) {
        this.gkList = []
        return
      }
      this.resetPage()
      if (e == 2) {
        this.getAllCs(false)
      } else {
        this.getDay(false)
      }
    },
    handleListScroll(e) {
      if (this.isSearchMode || this.listLoading || !this.hasMore) return
      const el = e.target
      if (el.scrollHeight - el.scrollTop <= el.clientHeight + 20) {
        if (this.activeNames == 2) {
          this.getAllCs(true)
        } else if (this.activeNames == 1) {
          this.getDay(true)
        }
      }
    },
    getAllCs(append = false) {
      if (this.listLoading || (append && !this.hasMore)) return
      this.listLoading = true
      let min = this.pageMin
      let max = min + this.pageSize - 1
      let loadingInstance = null
      if (!append) {
        loadingInstance = Loading.service({
          background: 'rgba(0, 0, 0, 0.7)',
          text: '加载中...'
        });
      }
      this._api.Company.getAllCs(max, min, this.tiem)
          .then(res => {
            if (loadingInstance) loadingInstance.close()
            this.listLoading = false
            let arr = res.GetListByChooseResult || []
            this.totalCount = Number(res.RecordCount) || 0
            this.gkList = append ? this.gkList.concat(arr) : arr
            this.pageMin = max + 1
            this.hasMore = this.gkList.length < this.totalCount
          })
          .catch(() => {
            if (loadingInstance) loadingInstance.close()
            this.listLoading = false
          })
    },
    getDay(append = false) {
      if (this.listLoading || (append && !this.hasMore)) return
      this.listLoading = true
      let min = this.pageMin
      let max = min + this.pageSize - 1
      let loadingInstance = null
      if (!append) {
        loadingInstance = Loading.service({
          background: 'rgba(0, 0, 0, 0.7)',
          text: '加载中...'
        });
      }
      this._api.Company.getDayCs(max, min)
          .then(res => {
            if (loadingInstance) loadingInstance.close()
            this.listLoading = false
            let arr = res.GetListByChooseResult || []
            this.totalCount = Number(res.RecordCount) || 0
            this.gkList = append ? this.gkList.concat(arr) : arr
            this.pageMin = max + 1
            this.hasMore = this.gkList.length < this.totalCount
          })
          .catch(() => {
            if (loadingInstance) loadingInstance.close()
            this.listLoading = false
          })
    },
    ling(item, idx) {
      this.dqGkIdx = idx
      // console.log(this.$store.state.users.csObj)
      this.cancellation()

      this.$store.commit('users/UpCsUser', item )
      this.$store.commit('users/upCsAge', item.CustomerAge)
      this.$store.commit('users/upCsUserItem', {
        name: item.CustomerName,
        tel: item.CustomerTel
      })



      // if (this.$store.state.Time.timeObj.customerLogin_normal) {
      //   this._api.publicApi.addTime('customerLogin_normal', ((new Date()).valueOf() - this.$store.state.Time.timeObj.customerLogin_normal.ENTER)/1000)
      // }
      // this.$store.commit('Time/initTimeObj', {
      //   keys: "customerLogin_normal",
      //   val: {
      //     ENTER: 0,
      //     EXIT: 0
      //   }
      // })
    },
    cancellation() {
      this.$store.commit('users/upCsUserItem', '')
      this.$store.commit('users/UpCsUser', '' )
      this.$store.commit('users/upCsAge', '')
      this.$store.commit('physicianVisits/upCancellation', true)
      this.$store.commit('physicianVisits/upXzConsulting',  '')
      this.$store.commit('isbc/upall', '')
      pf.clCsData()
      this.$emit('isLing', true)
    },
    searchCs() {
      this.activeNames = '2'
      this.isSearchMode = true
      this.hasMore = false
      this.dqGkIdx = -1
      let loadingInstance = Loading.service({
        background: 'rgba(0, 0, 0, 0.7)',
        text: '加载中...'
      });
      this._api.Company.searchCs(this.name, this.tiem)
          .then(res => {
            loadingInstance.close()
            if (res.GetListByChooseResult && res.GetListByChooseResult.length) {
              this.gkList = res.GetListByChooseResult
            }else {
              this.gkList = []
              this.$alert('暂无此顾客就诊信息，请先注册就诊', '提示')
            }
          })
    },
    gldl() {
      if (!this.names || !this.tel) {
        return this.$alert('请输入姓名或者电话！', '提示')
      }
      let loadingInstance = Loading.service({
        background: 'rgba(0, 0, 0, 0.7)',
        text: '加载中...'
      });
      this._api.userCurdApi.CsLanding(this.names, this.tel)
          .then(res => {
            loadingInstance.close();
            if (res.GetResult) {
              this.showZCMG = false
              let nian = pf.getYear(res.GetResult.CustomerBirthday)
              this.$store.commit('users/upLogged', true)   //更新登陆状态
              this.$store.commit('users/upCsUserItem', '')
              this.$store.commit('users/upCsAge', nian)
              this.$store.commit('users/UpCsUser', res.GetResult)
              this.$store.commit('physicianVisits/upCancellation', false)
              this.$emit('isLing', false)
            }else {
              this.$message.error('姓名或电话错误');
            }
          })
          .catch(err => {
            loadingInstance.close();
            // console.log(err)
          })
    },
    newzc() {
      this.showZCMG = false;
      this.showdhDL=false
      this.showSJZC = true
    },
    csZCS() {
      if (!this.csZcObj.tel || !this.csZcObj.sr || !this.csZcObj.name) {
        return this.$alert('请输入必要信息!', '提示')
      }
      if (!this.csZcObj.sex) {
        return  this.$msgbox('请选择性别！','提示', {
          confirmButtonText: '确定',
        })
      }
      if (this.csZcObj.sr && pf.getYear(this.csZcObj.sr) < 1) {
        return  this.$msgbox('年龄不得小于1岁！','提示', {
          confirmButtonText: '确定',
        })
      }
      let lo = this.$loading({
        text: '注册中...',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      this._api.userCurdApi.csZc(this.csZcObj.name, this.csZcObj.tel, this.csZcObj.sex, this.csZcObj.sr, '', '', this.csZcObj.xxdz)
          .then(res => {
            lo.close()
            if (res.Login190826Result) {
              let nian = pf.getYear(res.Login190826Result.CustomerBirthday)
              this.$store.commit('users/upLogged', true)   //更新登陆状态
              this.$store.commit('users/upCsUserItem', '')
              this.$store.commit('users/upCsAge', nian)
              this.$store.commit('users/UpCsUser', JSON.parse(JSON.stringify(res.Login190826Result)))
              this.$store.commit('physicianVisits/upCancellation', false)
              this.$emit('isLing', false)
              this.showSJZC = false
            }else {
              this.$alert('注册失败！', '提示')
            }
          })
    },
    dqBH() {

    },
    getsm() {
      if (window.bound) {
        window.bound.scanQRCode()
      }

      if (window.androids) {
        const  _this = this
        window.rdata = function (e) {
          if (e) {
            if (e != 99) {
              let loadingInstance = this.$loading({
                background: 'rgba(0, 0, 0, 0.7)',
                text: '登录中...'
              });
              _this._api.userCurdApi.codeLing(e)
                  .then(res => {
                    loadingInstance.close()
                    if (res.LoginOnCustomerNoResult) {
                      let obj = res.LoginOnCustomerNoResult.Customer
                      let nian = pf.getYear(obj.CustomerBirthday)
                      _this.$store.commit('users/upLogged', true)   //更新登陆状态
                      _this.$store.commit('users/upCsUserItem', '')
                      _this.$store.commit('users/upCsAge', nian)
                      _this.$store.commit('users/UpCsUser', obj)
                      _this.$store.commit('physicianVisits/upCancellation', false)
                      _this.$emit('isLing', false)
                    }
                  })
            }else {
              _this.$alert('扫码失败', '提示')
            }
          }
        }
        window.androids.sm("")
      }
    },
  }
}
</script>

<style scoped lang="scss">
.left {
  width: 230px;
  height: 100%;
  padding: 0 8px;
  overflow: hidden;
  overflow-y: auto;
}
.xx {
  li {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 400;
    color: rgba(56, 56, 56, 1);
    border-radius: 5px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 4px 1px rgba(0, 0, 0, 0.1);
    width: 100%;
    padding: 8px 0;
    margin: 8px 0;
    cursor: pointer;
    img {
      width: 20px;
      margin-left: 15px;
      margin-right: 10px;
    }
  }
  @media (max-width: 768px) {
    li {
      font-size: 13px;
    }
  }
}
.ssgk {
  border-radius: 8px;
  background: #FFFFFF;
  padding: 5px 0;
  margin-bottom: 8px;
  .ssk {
    position: relative;
    i {
      position: absolute;
      right: 10px;
      top: 8px;
      cursor: pointer;
    }
  }
}
.gklb {
  height: calc(100vh - 538px);
  background: #f6f6f6;
  overflow-y: auto;
  li {
    display: flex;
    align-items: center;
    padding: 5px;
    cursor: pointer;
    i {margin-right: 10px;}
    &:hover {background: #FFFFFF}
  }
  .xz {background: #FFFFFF}
  .list-tip {
    justify-content: center;
    color: #999;
    font-size: 12px;
    cursor: default;
    &:hover {background: transparent}
  }
}
.smzc {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
  .smbox {
    border-radius: 10px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px 2px rgba(0, 0, 0, 0.15);
    position: relative;
    width: 387px;
    height: 477px;
    position: relative;
    img {
      display: block;
      width: 160px;
      height: 160px;
      margin: 0 auto;
      margin-top: 111px;
      box-shadow: 0px 2px 19px 1px rgba(0, 0, 0, 0.25);
    }
    .smwz {
      font-size: 17px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      margin-top: 31px;
    }

    input {
      border-radius: 10px;
      border: 1px solid rgba(158, 158, 158, 1);
      width: 240px;
      outline: none;
      text-align: center;
      height: 50px;
    }
    .na {
      margin-top: 112px;
      margin-bottom: 40px;
    }
    .gkdlan {
      border-radius: 10px;
      background: rgb(61, 103, 255);
      color: rgba(255, 255, 255, 1);
      padding: 11px 0;
      width: 240px;
      margin: 0 auto;
      margin-top: 80px;
      cursor: pointer;
    }
  }
  .gbccss {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 20px;
    cursor: pointer;
  }
}
.zcsjbox {
  border-radius: 10px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px 2px rgba(0, 0, 0, 0.15);
  position: relative;
  width: 387px;
  height: 430px;
  z-index: 999;
  .gkdlan {
    border-radius: 10px;
    background: rgb(61, 110, 255);
    color: rgba(255, 255, 255, 1);
    padding: 11px 0;
    width: 240px;
    margin: 0 auto;
    margin-top: 70px;
    cursor: pointer;
  }
  .srbox {
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 15px;
    p {
      width: 5em;
      text-align: left;
    }
  }
  input {
    outline: none;
    width: 150px;
    border-radius: 5px;
    border: 1px solid #dcdcdc;
    padding: 7px;
  }
}
</style>
